<template>
  <div id="google_input">
    <input ref="full_address" 
    v-model="address_form.full_address" 
    @blur="checkAddress" 
    placeholder="הכנס כתובת מלאה" 
    type="text" 
    class="form-control">
  </div>
</template>

<script>
export default {
  props: ["data"],
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      is_loaded: false,
      autocomplete: null,
      address_form: {
        district: '',
        city: '',
        street: '',
        num_building: '',
        full_address: '',
        google_place_id: ''
      }
    }
  },
  beforeMount() {
    this.address_form = this.data;
  },
  mounted() {
    this.initAutocomplete();
    this.selectFirstOnEnter(this.$refs.full_address);

  },
  methods: {
    initAutocomplete() {
      if (typeof google === 'object' && typeof google.maps === 'object') {
        this.autocomplete = new google.maps.places.Autocomplete(this.$refs.full_address, { types: ['geocode'] });
        this.autocomplete.addListener('place_changed', this.fillInAddress);
        this.$refs.full_address.addEventListener('keydown', this.handleEnterKey);

        if (this.address_form.google_place_id) {
          this.getPlaceById(this.address_form.google_place_id);
        }
      } else {
        console.error('Google Maps script not loaded');
      }
    },
    selectFirstOnEnter(input) {
      const originalAddEventListener = input.addEventListener || input.attachEvent;

      function addEventListenerWrapper(type, listener) {
          if (type === "keydown") {
              const originalListener = listener;
              listener = function(event) {
                  const suggestionSelected = document.querySelector(".pac-item-selected") !== null;
                  if (event.which === 13 && !suggestionSelected) {
                      const simulatedDownArrow = new KeyboardEvent("keydown", { keyCode: 40, which: 40 });
                      originalListener.apply(input, [simulatedDownArrow]);
                  }
                  originalListener.apply(input, [event]);
              };
          }
          originalAddEventListener.apply(input, [type, listener]);
      }

      if (input.addEventListener) {
          input.addEventListener = addEventListenerWrapper;
      } else if (input.attachEvent) {
          input.attachEvent = addEventListenerWrapper;
      }
  },
    getPlaceById(placeId) {
      const request = {
        placeId: placeId,
        fields: ['address_components', 'formatted_address', 'geometry']
      };
      const service = new google.maps.places.PlacesService(this.$refs.full_address);

      service.getDetails(request, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          this.fillInAddress(place);
        } else {
          console.log('Failed to get place details:', status);
        }
      });
    },
    fillInAddress(place = false) {

      if (!place) {
        place = this.autocomplete.getPlace();
      }
          
   
      if (place?.address_components && place?.address_components.length) {
        this.address_form.num_building = '';
        this.address_form.street = '';
        this.address_form.city = '';
        this.address_form.district = '';
        for (const adr of place.address_components) {
          if (adr.types.includes('street_number')) {
            this.address_form.num_building = adr.long_name;
          }
          if (adr.types.includes('route')) {
            this.address_form.street = adr.long_name;
          }
          if (adr.types.includes('locality')) {
            this.address_form.city = adr.long_name;
          }
          if (adr.types.includes('administrative_area_level_1')) {
            this.address_form.district = adr.long_name;
          }
        }
        this.address_form.full_address = place.formatted_address;
        this.address_form.google_place_id = place.place_id;
      }

      this.$emit('update', this.address_form);
    },
    checkAddress() {
      if (!this.address_form.full_address) {
        // alert("Please enter a valid address.");
      }
    },
    // geolocate() {
    //   if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(position => {
    //       const geolocation = {
    //         lat: position.coords.latitude,
    //         lng: position.coords.longitude
    //       };
    //       const circle = new google.maps.Circle({ center: geolocation, radius: position.coords.accuracy });
    //       this.autocomplete.setBounds(circle.getBounds());
    //     });
    //   }
    // },
  },
  watch: {
    placeId() {
      this.getPlaceById(this.address_form.google_place_id);
    }
  },
    beforeUnmount() {
        // Remove event listener when component is destroyed
        this.$refs.full_address.removeEventListener('keydown', this.handleEnterKey);
    }
}
</script>

<style>
/* Add any required styles */
</style>
